import { gql, useMutation } from "@apollo/client";
import { DialogContent } from "@material-ui/core";
import { Form, Formik } from "formik";
import React from "react";
import { useAppDialog } from "../../../app-dialog";
import { AttendanceFragment, AttendanceModel } from "../../../models/attendance.model";
import { BasicDialogActions } from "../../../ui/dialog";
import { LoadingButton } from "../../../ui/loading-button";
import { AttendanceForm } from "./attendance.form";
import { AttendanceInitialValues, AttendanceValidationSchema, getTicketSubmission } from "./attendance.validation";

const MUTATION = gql`
    mutation insert($object: attendance_insert_input!) {
        insert_attendance_one(object: $object) {
            ${AttendanceFragment}
        }
    }
`;

type Props = {
    event_id: number;
    onFinish: (product: AttendanceModel, is_new?: boolean) => void;
}

export const AttendanceCreate = ({
    event_id,
    onFinish,
}: Props) => {
    const [insert, status] = useMutation(MUTATION)
    const app_dialog = useAppDialog();

    const onSubmit = async (values: any) => {
        try {
            const { data } = await insert({
                variables: {
                    object: {
                        ...getTicketSubmission(values),
                        event_id,
                    }
                }
            });
            const ticket = data?.insert_attendance_one;
            if (!ticket) {
                return;
            }
            onFinish(ticket, true);
        } catch (e: any) {
            app_dialog.showError(e);
        }
    }
    return <Formik initialValues={AttendanceInitialValues()}
        validationSchema={AttendanceValidationSchema}
        onSubmit={onSubmit}>{(form_props) => <Form noValidate>
            <DialogContent>
                <AttendanceForm {...form_props} />
            </DialogContent>
            <BasicDialogActions>
                <LoadingButton loading={status.loading}
                    color='primary'
                    type='submit'
                    size='large'
                    variant='contained'>
                    Create
                </LoadingButton>
            </BasicDialogActions>
        </Form>}
    </Formik>
}
